(function () {
  const STORAGE_KEY = 'label_source_favourites_v1';

  function getRoutesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getFavourites() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveFavourites(favourites) {
    const uniqueFavourites = [...new Set(favourites)];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(uniqueFavourites));
  }

  function isFavourite(handle) {
    return getFavourites().includes(handle);
  }

  function toggleFavourite(handle) {
    let favourites = getFavourites();

    if (favourites.includes(handle)) {
      favourites = favourites.filter(item => item !== handle);
    } else {
      favourites.unshift(handle);
    }

    saveFavourites(favourites);
    updateButtons();
    updateFavouriteCount();
    renderFavouritesPage();
  }

  function updateButtons() {
    const buttons = document.querySelectorAll('[data-ls-fav-button]');

    buttons.forEach(button => {
      const handle = button.dataset.productHandle;
      const active = isFavourite(handle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const icon = button.querySelector('[data-ls-fav-icon]');
      const text = button.querySelector('[data-ls-fav-text]');

      if (icon) icon.textContent = active ? '♥' : '♡';
      if (text) text.textContent = active ? 'Added to favourites' : 'Add to favourites';
    });
  }

  function updateFavouriteCount() {
    const countElements = document.querySelectorAll('[data-ls-favourites-count]');
    const count = getFavourites().length;

    countElements.forEach(element => {
      element.textContent = count;
      element.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  function formatMoney(cents) {
    const currency =
      window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'GBP';

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  async function fetchProduct(handle) {
    try {
      const routesRoot = getRoutesRoot();
      const response = await fetch(`${routesRoot}products/${handle}.js`);

      if (!response.ok) return null;

      return await response.json();
    } catch (error) {
      return null;
    }
  }

  function removeFavourite(handle) {
    const favourites = getFavourites().filter(item => item !== handle);

    saveFavourites(favourites);
    updateButtons();
    updateFavouriteCount();
    renderFavouritesPage();
  }

  async function renderFavouritesPage() {
    const container = document.getElementById('ls-favourites-page');
    if (!container) return;

    const favourites = getFavourites();

    if (!favourites.length) {
      container.innerHTML = `
        <div class="ls-favourites-empty">
          <h1>Your favourites</h1>
          <p>You haven’t favourited anything yet. Tap the heart on items you love and they’ll appear here.</p>
          <a href="/collections/all" class="ls-favourites-empty-link">Start shopping</a>
        </div>
      `;
      return;
    }

    container.innerHTML = `
      <div class="ls-favourites-loading">
        Loading your favourites...
      </div>
    `;

    const products = await Promise.all(
      favourites.map(handle => fetchProduct(handle))
    );

    const validProducts = products.filter(Boolean);

    if (!validProducts.length) {
      container.innerHTML = `
        <div class="ls-favourites-empty">
          <h1>Your favourites</h1>
          <p>Your saved items are no longer available.</p>
          <a href="/collections/all" class="ls-favourites-empty-link">Continue shopping</a>
        </div>
      `;
      return;
    }

    container.innerHTML = `
      <div class="ls-favourites-header">
        <h1>Your favourites</h1>
        <p>${validProducts.length} saved item${validProducts.length === 1 ? '' : 's'}</p>
      </div>

      <div class="ls-favourites-grid">
        ${validProducts.map(product => {
          const image = product.featured_image || '';
          const price = product.price ? formatMoney(product.price) : '';
          const available =
            product.variants && product.variants.some(variant => variant.available);

          return `
            <div class="ls-favourite-card">
              <a href="/products/${product.handle}" class="ls-favourite-card-link">
                <div class="ls-favourite-card-image-wrap">
                  ${
                    image
                      ? `<img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy">`
                      : `<div class="ls-favourite-card-placeholder"></div>`
                  }
                </div>

                <div class="ls-favourite-card-info">
                  <h2>${escapeHtml(product.title)}</h2>
                  ${price ? `<p class="ls-favourite-price">${price}</p>` : ''}
                  ${!available ? `<p class="ls-favourite-sold">Sold</p>` : ''}
                </div>
              </a>

              <button
                type="button"
                class="ls-remove-favourite"
                data-ls-remove-fav
                data-product-handle="${product.handle}"
              >
                Remove
              </button>
            </div>
          `;
        }).join('')}
      </div>
    `;
  }

  document.addEventListener('click', function (event) {
    const favouriteButton = event.target.closest('[data-ls-fav-button]');
    const removeButton = event.target.closest('[data-ls-remove-fav]');

    if (favouriteButton) {
      event.preventDefault();
      event.stopPropagation();

      const handle = favouriteButton.dataset.productHandle;
      if (handle) toggleFavourite(handle);

      return;
    }

    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();

      const handle = removeButton.dataset.productHandle;
      if (handle) removeFavourite(handle);

      return;
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateButtons();
    updateFavouriteCount();
    renderFavouritesPage();
  });

  /* Smart Shop footer link */
  const LS_LAST_SHOP_URL_KEY = 'label_source_last_shop_url_v1';
  const LS_RETURN_TO_SHOP_WITH_BACK_KEY = 'label_source_return_to_shop_with_back_v1';

  function lsIsShoppingPage() {
    const path = window.location.pathname.toLowerCase();
    const search = window.location.search.toLowerCase();
    const hash = window.location.hash.toLowerCase();

    if (path.startsWith('/products')) return false;
    if (path.startsWith('/cart')) return false;
    if (path.startsWith('/checkout')) return false;
    if (path.startsWith('/account')) return false;
    if (path.startsWith('/pages/favourites')) return false;

    if (path === '/') return true;
    if (path.startsWith('/collections')) return true;
    if (path.startsWith('/search')) return true;
    if (path.startsWith('/pages/shop')) return true;
    if (path.startsWith('/pages/shop-all')) return true;
    if (path.startsWith('/pages/search-results-page')) return true;

    if (search.includes('q=')) return true;
    if (search.includes('query=')) return true;
    if (search.includes('keyword=')) return true;
    if (search.includes('search')) return true;
    if (search.includes('snize')) return true;

    if (hash.includes('q=')) return true;
    if (hash.includes('query=')) return true;
    if (hash.includes('search')) return true;
    if (hash.includes('snize')) return true;

    return false;
  }

  function lsIsFavouritesPage() {
    return window.location.pathname.startsWith('/pages/favourites');
  }

  function lsCurrentRelativeUrl() {
    return window.location.pathname + window.location.search + window.location.hash;
  }

  function lsSaveCurrentShopLocation() {
    if (!lsIsShoppingPage()) return;

    const fullUrl = lsCurrentRelativeUrl();
    localStorage.setItem(LS_LAST_SHOP_URL_KEY, fullUrl);
  }

  function lsUpdateShopFooterLink() {
    const shopLinks = document.querySelectorAll('[data-ls-shop-nav]');
    if (!shopLinks.length) return;

    const savedUrl = localStorage.getItem(LS_LAST_SHOP_URL_KEY);

    shopLinks.forEach(link => {
      if (lsIsFavouritesPage() && savedUrl) {
        link.setAttribute('href', savedUrl);
      } else {
        link.setAttribute('href', '/');
      }
    });
  }

  window.addEventListener('beforeunload', function () {
    lsSaveCurrentShopLocation();
  });

  document.addEventListener('click', function (event) {
    const favouritesLink = event.target.closest('a[href*="/pages/favourites"]');

    if (favouritesLink && lsIsShoppingPage()) {
      lsSaveCurrentShopLocation();
      sessionStorage.setItem(LS_RETURN_TO_SHOP_WITH_BACK_KEY, '1');
    }
  });

  document.addEventListener('click', function (event) {
    const shopLink = event.target.closest('[data-ls-shop-nav]');

    if (!shopLink) return;
    if (!lsIsFavouritesPage()) return;

    const savedUrl = localStorage.getItem(LS_LAST_SHOP_URL_KEY) || '/';
    const shouldUseBack = sessionStorage.getItem(LS_RETURN_TO_SHOP_WITH_BACK_KEY) === '1';

    if (shouldUseBack && window.history.length > 1) {
      event.preventDefault();

      sessionStorage.removeItem(LS_RETURN_TO_SHOP_WITH_BACK_KEY);

      window.history.back();

      setTimeout(function () {
        if (lsIsFavouritesPage()) {
          window.location.href = savedUrl;
        }
      }, 700);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    lsSaveCurrentShopLocation();
    lsUpdateShopFooterLink();

    setTimeout(lsUpdateShopFooterLink, 500);
  });

  /* Searchanise collection/search grid hearts + Never Worn badge */
  let lsSearchaniseObserverStarted = false;
  let lsSearchaniseInjectTimer = null;

  function lsGetProductHandleFromUrl(url) {
    if (!url) return '';

    try {
      const parsedUrl = new URL(url, window.location.origin);
      const parts = parsedUrl.pathname.split('/').filter(Boolean);
      const productsIndex = parts.indexOf('products');

      if (productsIndex === -1) return '';

      return parts[productsIndex + 1] || '';
    } catch (error) {
      return '';
    }
  }

  function lsCreateSearchaniseHeart(handle) {
    const button = document.createElement('button');

    button.type = 'button';
    button.className = 'ls-card-favourite-button ls-searchanise-favourite-button';
    button.setAttribute('data-ls-fav-button', '');
    button.setAttribute('data-product-handle', handle);
    button.setAttribute('aria-label', 'Add to favourites');

    const icon = document.createElement('span');
    icon.setAttribute('data-ls-fav-icon', '');
    icon.textContent = isFavourite(handle) ? '♥' : '♡';

    button.appendChild(icon);

    if (isFavourite(handle)) {
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
    } else {
      button.setAttribute('aria-pressed', 'false');
    }

    return button;
  }

  function lsSearchaniseCardIsNeverWorn(card) {
    return (
      card.classList.contains('snize-product-tag-new') ||
      card.classList.contains('snize-product-tag-never-worn') ||
      card.classList.contains('snize-product-tag-never-worn-with-tags') ||
      card.classList.contains('snize-product-tag-new-with-tags') ||
      card.classList.contains('snize-product-tag-nwt')
    );
  }

  function lsInjectSearchaniseNeverWornBadge(card) {
    try {
      if (!lsSearchaniseCardIsNeverWorn(card)) return;
      if (card.querySelector('.ls-searchanise-never-worn')) return;

      const thumbnailWrapper = card.querySelector('.snize-thumbnail-wrapper');
      if (!thumbnailWrapper) return;

      thumbnailWrapper.classList.add('ls-searchanise-thumbnail-has-badge');

      const badge = document.createElement('span');
      badge.className = 'never-worn ls-searchanise-never-worn';
      badge.textContent = 'Never worn';

      thumbnailWrapper.prepend(badge);
    } catch (error) {}
  }

  function lsInjectSearchaniseHearts() {
    const cards = document.querySelectorAll('li.snize-product[id^="snize-product-"]');

    cards.forEach(card => {
      lsInjectSearchaniseNeverWornBadge(card);

      if (card.querySelector('.ls-searchanise-favourite-button')) return;

      const productLink =
        card.querySelector('a.snize-view-link[href*="/products/"]') ||
        card.querySelector('a[href*="/products/"]');

      if (!productLink) return;

      const handle = lsGetProductHandleFromUrl(productLink.getAttribute('href'));
      if (!handle) return;

      card.classList.add('ls-searchanise-card-has-heart');

      const button = lsCreateSearchaniseHeart(handle);
      card.prepend(button);
    });

    updateButtons();
    updateFavouriteCount();
  }

  function lsScheduleSearchaniseHeartInject() {
    if (lsSearchaniseInjectTimer) return;

    lsSearchaniseInjectTimer = setTimeout(function () {
      lsSearchaniseInjectTimer = null;
      lsInjectSearchaniseHearts();
    }, 150);
  }

  function lsStartSearchaniseHeartObserver() {
    if (lsSearchaniseObserverStarted) return;

    lsSearchaniseObserverStarted = true;

    const observer = new MutationObserver(function (mutations) {
      let shouldRun = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (
            node.matches &&
            (
              node.matches('li.snize-product[id^="snize-product-"]') ||
              node.matches('#snize-search-results-grid-mode') ||
              node.querySelector('li.snize-product[id^="snize-product-"]')
            )
          ) {
            shouldRun = true;
          }
        });
      });

      if (shouldRun) {
        lsScheduleSearchaniseHeartInject();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    lsInjectSearchaniseHearts();
    lsStartSearchaniseHeartObserver();

    setTimeout(lsInjectSearchaniseHearts, 500);
    setTimeout(lsInjectSearchaniseHearts, 1500);
  });

  window.addEventListener('load', function () {
    lsInjectSearchaniseHearts();
  });

  /* Refresh stale hearts/counts when returning from cached Shop/Search pages */
  function lsRefreshVisibleFavouriteUi() {
    updateButtons();
    updateFavouriteCount();
    lsInjectSearchaniseHearts();
  }

  function lsRefreshVisibleFavouriteUiWithDelays() {
    lsRefreshVisibleFavouriteUi();

    setTimeout(lsRefreshVisibleFavouriteUi, 150);
    setTimeout(lsRefreshVisibleFavouriteUi, 600);
    setTimeout(lsRefreshVisibleFavouriteUi, 1500);
  }

  window.addEventListener('pageshow', function () {
    lsRefreshVisibleFavouriteUiWithDelays();
  });

  window.addEventListener('focus', function () {
    lsRefreshVisibleFavouriteUiWithDelays();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      lsRefreshVisibleFavouriteUiWithDelays();
    }
  });

})();